import React from "react";
import { FaBolt,
  FaFire,
  FaTint,
  FaTv,
  FaFileAlt,
  FaMobileAlt,
  FaWifi,
  FaCreditCard,
  FaUniversity,
  FaCar,FaClock,
  FaChartLine,
  FaPhoneAlt,
  FaArrowRight,
  FaMoneyBillWave,
  FaEnvelopeOpenText,
  FaCogs,FaHeadset } from "react-icons/fa";

import { FaShieldAlt, FaUsers, FaExchangeAlt } from "react-icons/fa";

const BBPSService = () => {
  const services = [
  {
    icon: <FaBolt size={28} color="#ffffff" />,
    title: "Electricity Bills",
    description: "Pay your electricity bills from all major providers across India",
  },
  {
    icon: <FaFire size={28} color="#ffffff" />,
    title: "Gas Cylinder & Pipeline",
    description: "LPG cylinder bookings and gas pipeline bill payments",
  },
  {
    icon: <FaTint size={28} color="#ffffff" />,
    title: "Water Bills",
    description: "Municipal water bill payments for all major cities",
  },
  {
    icon: <FaTv size={28} color="#ffffff" />,
    title: "DTH & Cable TV",
    description: "Recharge your DTH and cable TV subscriptions instantly",
  },
  {
    icon: <FaMobileAlt size={28} color="#ffffff" />,
    title: "Mobile Prepaid & Postpaid",
    description: "Mobile recharges and postpaid bill payments for all operators",
  },
  {
    icon: <FaWifi size={28} color="#ffffff" />,
    title: "Broadband & Landline",
    description: "Internet and landline bill payments for all service providers",
  },
  {
    icon: <FaCreditCard size={28} color="#ffffff" />,
    title: "Loan EMIs",
    description: "Pay your loan EMIs securely through BBPS platform",
  },
  {
    icon: <FaShieldAlt size={28} color="#ffffff" />,
    title: "Insurance Premiums",
    description: "Life, health, and general insurance premium payments",
  },
  {
    icon: <FaUniversity size={28} color="#ffffff" />,
    title: "Municipal Taxes",
    description: "Property tax and other municipal tax payments",
  },
  {
    icon: <FaCar size={28} color="#ffffff" />,
    title: "Fastag Recharge",
    description: "Recharge your Fastag for seamless toll payments",
  },
];

 const features = [
    {
      icon: <FaClock size={24} color="#fff" />,
     bgColor: "#4CAF50", // green
      title: "Real-Time Payments",
      emoji: "⏱️",
      desc: "Instant bill payments with immediate confirmation and receipt generation",
    },
    {
      icon: <FaShieldAlt size={24} color="#fff" />,
      bgColor: "#FF6B6B", // red
      title: "Secure & RBI-Compliant",
      emoji: "🔒",
      desc: "Bank-grade security with full RBI compliance for safe transactions",
    },
    {
      icon: <FaChartLine size={24} color="#fff" />,
       bgColor: "#4C6EF5", // blue
      title: "100% Uptime",
      emoji: "📈",
      desc: "Reliable service with guaranteed uptime for uninterrupted bill payments",
    },
    {
      icon: <FaFileAlt size={24} color="#fff" />,
          bgColor: "#FFA726", // orange
      title: "Transaction Reports",
      emoji: "📊",
      desc: "Comprehensive reporting for all your payment transactions",
    },
    {
      icon: <FaMoneyBillWave size={24} color="#fff" />,
         bgColor: "#9C27B0", // purple
      title: "Instant Settlements",
      emoji: "💸",
      desc: "Quick settlement processing for faster fund transfers",
    },
    {
      icon: <FaCogs size={24} color="#fff" />,
      bgColor: "#059669",
      title: "API & Dashboard Integration",
      emoji: "🔧",
      desc: "Easy integration with robust APIs and intuitive dashboard",
    },
    {
      icon: <FaMobileAlt size={24} color="#fff" />,
      bgColor: "#dfd217ff",
      title: "Mobile Friendly Interface",
      emoji: "📱",
      desc: "Responsive design optimized for all devices and screen sizes",
    },
    {
      icon: <FaUsers size={24} color="#fff" />,
  bgColor: "#00ACC1", // teal
      title: "Partner Support",
      emoji: "🤝",
      desc: "Dedicated support team for seamless onboarding and operations",
    },
  ];
  

  return (

    <>
    <section
      style={{
        background: "linear-gradient(135deg, #faf3d0ff, #d7faeaff)",
        color: "Black",
        padding: "40px 40px",
        textAlign: "left",
        position: "relative",
        overflow: "hidden",
        fontFamily: "Segoe UI, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes slideInLeft {
            0% {
              transform: translateX(-50px);
              opacity: 0;
            }
            100% {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes zoomIn {
            0% {
              transform: scale(0.8);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }

          .animated-left {
            animation: slideInLeft 1s ease-out forwards;
          }

          .zoom-in {
            animation: zoomIn 1s ease-out forwards;
          }
        `}
      </style>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1200px",
          margin: "0 auto",
          flexWrap: "wrap",
          gap: "40px",
          zIndex: 2,
          position: "relative",
        }}
      >
        {/* Left Content */}
        <div style={{ flex: "1 1 500px" }} className="animated-left">
          <h1 style={{ fontSize: "40px", fontWeight: "bold", marginBottom: "10px" }}>
            Your One-Stop Bill Payment Solution
          </h1>

          <p
            style={{
              fontSize: "18px",
              maxWidth: "700px",
              lineHeight: 2,
            }}
          >
            Simplify bill payments with the <strong>Bharat Bill Payment System</strong>. Pay
            electricity, gas, water, DTH, mobile recharges, and more – all in one secure platform.
          </p>

         

          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "30px",
              flexWrap: "wrap",
              paddingTop:"30px"
            }}
          >
            <button
              style={{
                fontSize: "16px",
                padding: "10px 16px",
                borderRadius: "10px",
                cursor: "pointer",
                display: "flex",
                gap: "10px",
                alignItems: "center",
                backgroundColor: "Green",
                color: "#ffffffff",
                
                fontWeight: "600",
                border: "none",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            >
              <FaBolt /> Get Started Now →
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div style={{ flex: "1 1 400px", textAlign: "center" }} className="zoom-in">
          <img
            src="/assets/images/bbps.png"
            alt="Bill Payment Illustration"
            style={{
              width: "100%",
              maxWidth: "600px",
              height: "auto",
              borderRadius: "12px",
            }}
          />
        </div>
      </div>
    </section>
      <section
        style={{
          padding: "60px 20px",
          fontFamily: "Segoe UI, sans-serif",
          backgroundColor: "#fff",
          textAlign: "center",
        }}
      >
        {/* Title */}
        <h2 style={{ fontSize: "38px", fontWeight: "700", marginBottom: "1rem" }}>
          <span style={{ color: "#3b82f6", fontSize: "40px" }}>◆ </span>
        One Platform - Every Payment.
        </h2>

        {/* Description */}
        <p
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            fontSize: "20px",
            color: "#1f2937",
            lineHeight: "1.6",
          }}
        >
          The{" "}
          <a
            href="#"
            style={{ color: "#2563eb", textDecoration: "none", fontWeight: 600 }}
          >
            Bharat Bill Payment System (BBPS)
          </a>{" "}
          is a centralized platform launched by{" "}
          <a
            href="#"
            style={{ color: "#2563eb", textDecoration: "none", fontWeight: 600 }}
          >
            NPCI (National Payments Corporation of India)
          </a>{" "}
          to offer interoperable and accessible bill payment services across India.
        </p>

        {/* Subtitle */}
        <p
          style={{
            maxWidth: "800px",
            margin: "1rem auto 3rem",
            fontSize: "18px",
            color: "#6b7280",
          }}
        >
          It simplifies bill payments by bringing various utility providers and service
          consumers onto a single unified platform, making it easier than ever to manage
          all your bill payments in one place.
        </p>

        {/* Features Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "1.5rem",
            maxWidth: "1300px",
            margin: "0 auto 3rem",
          }}
        >

          {/* Feature Card 1 */}
          <div
            style={{
              backgroundColor: "#ffffffff",
              borderRadius: "1rem",
              padding: "1.5rem",
              boxShadow: "0 1px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 1px 6px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#2563eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 10px",
              }}
            >
              <FaShieldAlt size={28} color="#ffffff" />
            </div>
            <h4 style={{ fontWeight: "600", marginBottom: "6px" }}>RBI Regulated</h4>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>
              Fully regulated by Reserve Bank of India for maximum security
            </p>
          </div>

          {/* Feature Card 2 */}
          <div
            style={{
              backgroundColor: "#ffffffff",
              borderRadius: "1rem",
              padding: "1.5rem",
              boxShadow: "0 1px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 1px 6px rgba(0, 0, 0, 0.05)";
            }}
          >

            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#059669", // Blue background
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 10px", // Center and space below
              }}
            >
              <FaUsers size={28} color="#ffffff" />
            </div>

            <h4 style={{ fontWeight: "600", marginBottom: "6px" }}>Unified Platform</h4>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>
              All billers and payment services in one centralized system
            </p>
          </div>


          {/* Feature Card 3 */}
          <div
            style={{
              backgroundColor: "#ffffffff",
              borderRadius: "1rem",
              padding: "1.5rem",
              boxShadow: "0 1px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 1px 6px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#2563eb", // Blue background
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 10px", // Center and space below
              }}
            >
              <FaExchangeAlt size={28} color="#ffffff" />
            </div>
            <h4 style={{ fontWeight: "600", marginBottom: "6px" }}>Interoperable</h4>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>
              Works across all banks and payment service providers
            </p>
          </div>

          {/* Feature Card 4 */}
          <div
            style={{
              backgroundColor: "#ffffffff",
              borderRadius: "1rem",
              padding: "1.5rem",
              boxShadow: "0 1px 6px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              transform: "translateY(0)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 1px 6px rgba(0, 0, 0, 0.05)";
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#059669", // Blue background
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 10px", // Center and space below
              }}
            >
              <FaBolt size={28} color="#ffffff" />
            </div>
            <h4 style={{ fontWeight: "600", marginBottom: "6px" }}>Accessible</h4>
            <p style={{ fontSize: "16px", color: "#6b7280" }}>
              Easy access through multiple channels and devices
            </p>
          </div>
        </div>

        {/* Bottom Highlight Banner */}
        <div
          style={{
            background: "linear-gradient(to right, #5d85dbff, #03b37bff)",
            color: "white",
            borderRadius: "10px",
            padding: "2.5rem 1rem",
            maxWidth: "1000px",
            margin: "40px auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
            textAlign: "center",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)",
          }}
        >
          <div style={{ width: "100%", marginBottom: "2rem" }}>
            <h2
              style={{
                fontSize: "38px",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              Powering India's Digital Bill Payment Revolution
            </h2>
          </div>

          <div>
            <h3
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginBottom: "0.25rem",
              }}
            >
              1000+
            </h3>
            <p style={{ fontSize: "16px" }}>Billers Connected</p>
          </div>

          <div>
            <h3
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginBottom: "0.25rem",
              }}
            >
              24/7
            </h3>
            <p style={{ fontSize: "16px" }}>Service Availability</p>
          </div>

          <div>
            <h3
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginBottom: "0.25rem",
              }}
            >
              Pan-India
            </h3>
            <p style={{ fontSize: "16px" }}>Coverage</p>
          </div>
        </div>

      </section>

      <section
  style={{
    padding: "20px 20px",
    backgroundColor: "#f9fafb",
    fontFamily: "Segoe UI, sans-serif",
  }}
>
  <div
    style={{
      maxWidth: "1300px",
      margin: "0 auto",
      textAlign: "center",
    }}
  >
    {/* Header */}
    <h2 style={{ fontSize: "40px", fontWeight: "bold", marginBottom: "10px" }}>
      ✅ Services You Can Pay for Through BBPS
    </h2>
    <p style={{ color: "#6b7280", fontSize: "18px", marginBottom: "40px" }}>
      From utility bills to insurance premiums, pay for all your essential services through our unified platform
    </p>

    {/* Grid Cards */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "20px",
      }}
    >
      {services.map((service, index) => {
        const iconColors = [
          "#2563eb", // blue
          "#f97316", // orange
          "#10b981", // green
          "#a855f7", // purple
          "#ef4444", // red
          "#0ea5e9", // sky blue
          "#facc15", // yellow
          "#ec4899", // pink
          "#14b8a6", // teal
        ];

        const bgColor = iconColors[index % iconColors.length];

        return (
          <div
            key={index}
            style={{
              backgroundColor: "#ffffff",
              padding: "20px",
              borderRadius: "12px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              textAlign: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)";
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: bgColor,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 15px",
                color: "white",
              }}
            >
              {service.icon}
            </div>
            <h4 style={{ fontWeight: "600", marginBottom: "6px", fontSize: "17px" }}>
              {service.title}
            </h4>
            <p style={{ fontSize: "14px", color: "#6b7280" }}>{service.description}</p>
          </div>
        );
      })}
    </div>
  </div>
</section>
{/* <section className="terms-section">
  <style>{`
    .terms-section {
      padding: 40px 10px;
      background: #f8fafc;
    }

    .terms-container {
      max-width: 1200px;
      margin: 0 auto;
    }

    .terms-heading {
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 30px;
      color: #111827;
      text-align: left;
    }

    .terms-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .terms-item {
      background: #ffffff;
      padding: 15px 20px;
      border-radius: 16px;
      text-decoration: none;
      color: #065f46;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
    }

    .terms-item:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
    }

    .terms-left {
      display: flex;
      align-items: center;
      gap: 14px;
      font-size: 18px;
      font-weight: 500;
    }

    .terms-icon {
      background: #d1fae5;
      color: #065f46;
      padding: 10px;
      border-radius: 10px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .terms-arrow {
      font-size: 24px;
      color: #065f46;
      font-weight: bold;
    }

    @media (max-width: 768px) {
      .terms-heading {
        font-size: 26px;
        text-align: center;
      }

      .terms-item {
        padding: 16px 18px;
      }

      .terms-left span {
        font-size: 15px;
      }
    }
  `}</style>

  <div className="terms-container">

    <h3 className="terms-heading">
        Policies & Agreements
    </h3>

    <div className="terms-list">

      <a href="/docs/terms-english" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms & Conditions – English</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/terms-hindi" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms & Conditions – Hindi</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/terms-kannada" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms & Conditions – Kannada</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/csr-agreement" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>Terms of Reference of CSR Program Tripartite Agreement</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

    </div>

  </div>
</section> */}

    <section className="ta-support-section">
          <div className="ta-support-container ">
            
            {/* Header Area */}
            <div className="ta-support-header">
              <span className="ta-support-badge">BBPS Bill Pay Help Center</span>
              <h3><b>BBPS Support Services</b></h3>
              <p className="ta-support-subtext">
                Facing issues with bill settlements, failed BBPS transactions, or agent onboarding? 
            Our BBPS desk is active 24/7 to resolve your payment queries.
              </p>
            </div>
    
            {/* Support Cards Grid */}
            <div className="ta-support-grid">
              
              {/* Card 1: Phone (Click to Call) */}
              <div className="ta-support-card">
                <div className="ta-card-icon phone-icon">
                  <FaPhoneAlt />
                </div>
                <div className="ta-card-content">
                  <h3>Nodal Officer</h3>
                  <p>+91 8919056119</p>
                  <small>Instant support for failed bills</small>
                </div>
                <div className="ta-card-arrow">
                  <FaArrowRight />
                </div>
              </div>
    
              {/* Card 2: Email (Click to Email) */}
              <div className="ta-support-card">
                <div className="ta-card-icon email-icon">
                  <FaEnvelopeOpenText />
                </div>
                <div className="ta-card-content">
                  <h3>Nodal Officer Email</h3>
                  <p>kirankumar.p@taipl.in</p>
                  <small>For reconciliation & refunds</small>
                </div>
                <div className="ta-card-arrow">
                  <FaArrowRight />
                </div>
              </div>
    
              {/* Card 3: Ticket (Primary Action) */}
              <a href="https://udir.transactionanalysts.com/customergrievance" target="_blank" rel="noopener noreferrer" className="ta-support-card ta-card-primary">
                <div className="ta-card-icon ticket-icon">
                  <FaHeadset />
                </div>
                <div className="ta-card-content">
                  <h3>Raise Bill Dispute</h3>
                  <p>BBPS Portal</p>
                  <small>Track transaction status 24/7</small>
                </div>
                <div className="ta-card-arrow">
                  <FaArrowRight />
                </div>
              </a>
    
            </div>
          </div>
        </section>

    </>
  );
};

export default BBPSService;
